<div [ngClass]="{ noScores: tab === 2, '': tab === 1 }" class="pnl-dashboard">
  <header>
    <nav>
      <a (click)="changeTab(1)" class="lz" [class.active]="tab == 1"
        >Consolidado</a
      >
      <a (click)="changeTab(2)" class="rz" [class.active]="tab == 2"
        >Por loja</a
      >
      <span></span>
    </nav>
  </header>
  <dash-avaliacoes-graph
    (graphScreen)="openCloseGraphScreen()"
    *ngIf="graphScreen === true"
  ></dash-avaliacoes-graph>
  <dash-pedidos *ngIf="tab === 1"></dash-pedidos>
  <dash-rupturas *ngIf="tab === 1"></dash-rupturas>
  <dash-orderslist *ngIf="tab === 1"></dash-orderslist>
  <dash-avaliacoes
    (graphScreen)="openCloseGraphScreen()"
    class="dash-avaliacoes"
    *ngIf="tab === 1"
  ></dash-avaliacoes>
  <dash-porloja *ngIf="tab === 2"></dash-porloja>
</div>
